import React, { useState, useEffect } from "react";
import {
  CardTitle,
} from "reactstrap";
//redux
import { connect } from "react-redux";
//paginação
import Pagination from "../../../../components/Paginationv3";
// backdrops
import Alert from '../../../../components/Backdrops/Alert';
import Loading from '../../../../components/Backdrops/Loading';
// router
import { useLocation } from "react-router-dom";
//service
import scheduleCheckinUniqueNumberService from "../../../../utils/services/accreditation/scheduleCheckinUniqueNumber";
import scheduleService from "../../../../utils/services/accreditation/schedule";
import plusXMiceIdService from "../../../../utils/services/accreditation/plusXMiceId";
import PlusXMiceIdModel from '../../../../utils/models/PlusXMiceIdModel';
import writeXlsxFile from "write-excel-file";
import moment from 'moment';

import CommandButtons from './CommandButtons';
import EventNotActive from './EventNotActive';
import GuestsList from './GuestsList';

function GuestUniqueNumberReport(props) {

  const location = useLocation();
  const eventId = location.state.idEvent;

  const [loadingControl, setLoadingControl] = useState({
    open: false,
    message: '',
  });
  const [alertControl, setAlertControl] = useState({
    open: false,
    title: '',
    message: '',
    status: '', // success, warning, error
  });
  const [plusXMiceId, setPlusXMiceId] = useState(PlusXMiceIdModel());
  const plusXMiceIdRef = React.useRef(PlusXMiceIdModel());
  const [schedules, setSchedules] = useState([]);
  const [guestsList, setGuestsList] = useState([]);
  // loading
  const [loading, setLoading] = useState(false);
  const [searchControl, setSearchControl] = React.useState({
    search: '',
    schedule: '',
    total: 0,
  });
  const searchControlRef = React.useRef(searchControl);
  React.useEffect(() => {
    searchControlRef.current = searchControl;
  }, [searchControl]);
  const lastSearchStringUpdate = React.useRef(Date.now());
  const [currentIndex, setCurrentIndex] = useState(1);
  const currentIndexRef = React.useRef(currentIndex);
  const isMountedRef = React.useRef(false);
  React.useEffect(() => {
    currentIndexRef.current = currentIndex;
    if (isMountedRef.current) {
      getData();
    }
  }, [currentIndex]);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const itemsPerPageRef = React.useRef(itemsPerPage);
  React.useEffect(() => {
    itemsPerPageRef.current = itemsPerPage;
    if (isMountedRef.current) {
      getData();
    }
  }, [itemsPerPage]);

  useEffect(() => {
    isMountedRef.current = true;
    getData();
  }, []);

  const getData = React.useCallback(async () => {
    try {
      setLoadingControl({ ...loadingControl, open: true, message: 'Carregando' });

      let _plusXMiceId = { ...plusXMiceIdRef.current };
      if (!_plusXMiceId.miceId) {
        _plusXMiceId = await plusXMiceIdService.getPlusXMiceId(eventId);
        plusXMiceIdRef.current = _plusXMiceId;
        setPlusXMiceId(_plusXMiceId);
        if (!_plusXMiceId.active) {
          return;
        }
      }

      let _scheduleId = searchControlRef.current.schedule;
      if (!_scheduleId) {
        const _schedules = await scheduleService.getSchedules(_plusXMiceId.miceId);
        setSchedules(_schedules.data);
        _scheduleId = _schedules.data.length > 0 ? _schedules.data[0].id : '';
      }

      if (!_scheduleId) {
        setGuestsList([]);
        setSearchControl({ ...searchControlRef.current, total: 0 });
        return;
      }

      let _offset = (currentIndexRef.current - 1) * itemsPerPageRef.current;
      let _guests = await scheduleCheckinUniqueNumberService.getScheduleCheckinUniqueNumbers(
        _plusXMiceId.miceId,
        _scheduleId,
        itemsPerPageRef.current,
        _offset,
        searchControlRef.current.search,
      );

      setGuestsList(_guests.data);
      setSearchControl({ ...searchControlRef.current, schedule: _scheduleId, total: _guests.count });

    } catch (error) {
      console.log('Error getData', error);
      setAlertControl({
        open: true,
        title: 'Erro',
        message: error.message || 'Não foi possível realizar esta operação',
        status: 'error', // success, warning, error
      });
    } finally {
      setLoadingControl({ ...loadingControl, open: false });
    }
  }, []);

  const getReport = React.useCallback(async () => {
    try {
      setLoadingControl({ ...loadingControl, open: true, message: 'Buscando' });

      const _guestsList = await getGuestsList();

      await createXlsx(_guestsList);

    } catch (error) {
      console.log('Error getData', error);
      setAlertControl({
        open: true,
        title: 'Erro',
        message: error.message || 'Não foi possível realizar esta operação',
        status: 'error', // success, warning, error
      });
    } finally {
      setLoadingControl({ ...loadingControl, open: false });
    }

    async function getGuestsList() {
      let _offset = 0;
      let _perPage = 500;
      let _guestsList = [];
      let _guestsCount = 0;
      do {
        let _guests = await scheduleCheckinUniqueNumberService.getScheduleCheckinUniqueNumbers(
          plusXMiceId.miceId,
          searchControlRef.current.schedule,
          _perPage,
          _offset,
          '',
        );
        _offset += _perPage;
        _guestsList = [..._guestsList, ..._guests.data];
        _guestsCount = _guests.count;

      } while (_guestsCount > _guestsList.length);
      return _guestsList;
    }

    async function createXlsx(list = []) {
      const _schedule = schedules.find((s) => `${s.id}` === `${searchControlRef.current.schedule}`);
      const schema = [
        {
          column: "Número",
          type: Number,
          value: (guest) => guest.serialNumber,
        },
        {
          column: "ID Participante",
          type: Number,
          value: (guest) => guest.guestId,
        },
        {
          column: "Nome",
          type: String,
          value: (guest) => guest.guestName,
        },
        {
          column: "E-mail",
          type: String,
          value: (guest) => guest.guestEmail,
        },
      ];

      await writeXlsxFile(list, {
        schema,
        fileName: `Relatório Número Único Evento ${plusXMiceId.miceId}${_schedule ? ` - ${_schedule.title}` : ''} - ${moment().format('YYYY-MM-DD HH-MM')}.xlsx`,
      });
    }
  }, [plusXMiceId, schedules]);

  if (!plusXMiceId.active) {
    return (
      <EventNotActive />
    )
  }
  return (
    <div>
      <CardTitle>Relatório de Número Único</CardTitle>
      <CommandButtons
        searchControl={searchControl}
        setSearchControl={setSearchControl}
        schedules={schedules}
        lastSearchStringUpdate={lastSearchStringUpdate}
        getData={getData}
        getReport={getReport}
      />
      <GuestsList
        guestsList={guestsList}
        loading={loading}
      />
      <Pagination
        data={guestsList}
        search={searchControl.search}
        currentIndex={currentIndex}
        setCurrentIndex={setCurrentIndex}
        countData={searchControl.total}
        maxItemPerPage={itemsPerPage}
        setMaxItemPerPage={setItemsPerPage}
        maxPageButtonsToShow={3}
      />

      <Loading loadingControl={loadingControl} />
      <Alert
        alertControl={alertControl}
        setAlertControl={setAlertControl}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return { state };
};

export default connect(mapStateToProps)(GuestUniqueNumberReport);
